/**
 * Canvas Utilities — Shared rendering helpers for hole visualisation.
 *
 * roundRect, buildHeatmap, and adjustHexLightness were removed when the canvas
 * renderer was replaced by HoleHexGrid (SVG-based). The remaining exports are
 * used by HoleHexGrid.
 */

/**
 * Map landing counts to a heatmap colour (yellow → orange → red → purple).
 * Standard heatmap palette for this project — see visualisation_colours.md.
 * @param {number} intensity - 0 to 1
 * @returns {string} CSS rgba colour
 */
export function heatColour(intensity) {
  const t = Math.min(1, intensity);
  if (t < 0.25) {
    const a = t / 0.25;
    return `rgba(255, 255, 0, ${0.15 + a * 0.35})`;
  }
  if (t < 0.5) {
    const a = (t - 0.25) / 0.25;
    const g = Math.round(255 * (1 - a) + 165 * a);
    return `rgba(255, ${g}, 0, ${0.5 + a * 0.2})`;
  }
  if (t < 0.75) {
    const a = (t - 0.5) / 0.25;
    const g = Math.round(165 * (1 - a));
    return `rgba(255, ${g}, 0, ${0.7 + a * 0.15})`;
  }
  const a = (t - 0.75) / 0.25;
  const b = Math.round(a * 180);
  return `rgba(${Math.round(255 - a * 60)}, 0, ${b}, ${0.85 + a * 0.1})`;
}

/** Palette for numbered shot markers in replay view. */
export const SHOT_COLOURS = ['#3B82F6', '#EF4444', '#F59E0B', '#10B981', '#8B5CF6', '#EC4899'];
